export default {
	data() {
		return {
			menuVisble: false,
		};
	},
	methods: {
		openExcel() {
			this.exportColumnArr = JSON.parse(JSON.stringify(this.renderArr)); // 深拷贝
			let pushArr = [];
			if (this.$options.name == "dbkd" || this.$options.name == "pdkd" || this.$options.name == "xdkd") {
				pushArr = [
					{
						isFixed: false,
						isSortable: false,
						label: "商品序号",
						minWidth: 150,
						show: true,
						value: "spxh",
						width: 150,
						specialMask: true,
						isedit: false,
						align: "left",
					},
					{
						isFixed: false,
						isSortable: false,
						label: "#",
						minWidth: 50,
						show: true,
						value: "ii",
						width: 50,
						specialMask: true,
						isedit: false,
					},
				];
			} else {
				pushArr = [
					{
						isFixed: false,
						isSortable: false,
						label: "商品序号",
						minWidth: 150,
						show: true,
						value: "spxh",
						width: 150,
						specialMask: true,
						isedit: false,
						align: "left",
					},
					{
						isFixed: false,
						isSortable: false,
						label: "仓库",
						minWidth: 50,
						show: true,
						value: "ckbh",
						width: 50,
						specialMask: true,
						isedit: false,
					},
					{
						isFixed: false,
						isSortable: false,
						label: "#",
						minWidth: 50,
						show: true,
						value: "ii",
						width: 50,
						specialMask: true,
						isedit: false,
					},
				];
			}
			for (const v of pushArr) {
				if (v.show && v.specialMask) {
					this.exportColumnArr.unshift(v);
				}
			}
			this.kdExPortColumnDialogVisible = true;
		},
		// 跳转网站
		async chawangjia(spbh) {
			window.open(`http://hkrj.zqpj.com/?tuhao=${spbh}`);
		},
		// 保存渲染列
		SettingsRenderArr() {
			let name = this.$options.name;
			let str = name + "_renderArr";

			const settings = JSON.parse(localStorage.getItem("settings")) || {};
			if (
				settings &&
				settings.renderArr &&
				settings.renderArr[name] &&
				settings.renderArr[name][str] &&
				settings.renderArr[name][str].length
			) {
				this.getRenderArr();
				this.renderArr = this.renderArrQC(settings.renderArr[name][str], this.renderArr);
			} else {
				this.getRenderArr();
			}
		},
		// 保存页面表头数据和重置
		saveRenderArr(arr) {
			let name = this.$options.name;
			let str = name + "_renderArr";
			this.addSetting(str, arr, "renderArr", name);
			this.saveSettings();
			if (!arr.length) {
				this.getRenderArr();
				// 列控制组件重新拷贝数据
				this.$nextTick(() => {
					this.$refs.columnControl.deepClone();
					this.$message({
						message: this.$t("设置成功"),
						type: "success",
					});
				});
			}
		},
		// 拉伸宽度保存
		headerDragend(newWidth, oldWidth, column, event) {
			setTimeout(() => {
				const item = this.renderArr.find((item) => this.$t(item.label) === column.label);
				item.minWidth = parseInt(column.width);
				this.saveRenderArr(this.renderArr);
			}, 500);
		},
		//renderArr合并去重
		renderArrQC(arr1, arr2) {
			const map = {};
			arr1.forEach((item, index) => {
				map[item.label] = index;
			});

			return arr2
				.map((item) => {
					return arr1.find((item1) => item1.label === item.label) || item;
				})
				.sort((a, b) => {
					return map[a.label] - map[b.label];
				});
		},

		// 其他打印页
		QTPrint(dh, routeName, printImmediate = 1) {
			let name = this.$route.name;
			if (routeName && typeof routeName == "string" && routeName != "") name = routeName;
			console.log(name);
			this.$router.push({
				name: "QTPrint",
				query: {
					name,
					printImmediate, //0直接打印；1打印设置
					dh,
				},
			});
		},
		sfkPrint(dh, routeName, printImmediate = 1) {
			let name = this.$route.name;
			if (routeName && typeof routeName == "string" && routeName != "") name = routeName;
			this.$router.push({
				name: "sfkPrint",
				query: {
					name,
					printImmediate, //0直接打印；1打印设置
					dh,
				},
			});
		},
		// 右键点击当前行事件
		menuFn(event) {
			event.preventDefault();
			let showDiv = document.getElementsByClassName(this.$options.name);
			let menu = showDiv.length ? document.getElementsByClassName(this.$options.name)[0] : document.getElementById("menu");
			// 根据事件对象中鼠标点击的位置，进行定位
			if (menu) {
				const windowHeight = window.innerHeight;
				const scrollTop = window.scrollY || document.documentElement.scrollTop;
				const bottomThreshold = 20; // 定义一个底部阈值

				// 计算鼠标相对于视口的位置
				const clientY = event.clientY + scrollTop;

				// 判断鼠标是否靠近页面底部
				if (clientY + menu.offsetHeight > windowHeight + scrollTop - bottomThreshold) {
					// 鼠标靠近底部，将菜单显示在鼠标右侧上方
					menu.style.left = event.pageX - 180 + "px"; // 向右偏移一定的距离
					menu.style.top = event.pageY - (menu.offsetHeight + 70) + "px"; // 向上偏移更多以确保菜单完全可见
				} else {
					// 默认情况下，菜单显示在鼠标左侧下方
					menu.style.left = event.pageX - 180 + "px";
					menu.style.top = event.pageY - 70 + "px";
				}

				menu.style.display = "block";
				menu.style.zIndex = 1000;
			}
		},
		// 右键点击当前行事件
		rightClick(row, column, event) {
			this.menuinfo = row;
			this.menuFn(event);
			this.$refs.spTable.setCurrentRow(row);
		},
		// 右键点击当前头部事件
		rightClickHeader(row, event) {
			this.menuinfo = row;
			this.menuFn(event);
		},
		// 右键点击当前头部事件--临时
		rightClickHeader1(row, event) {
			this.menus = [{ label: "自定义显示列", name: "自定义显示列", icon: "el-icon-open" }];
			this.menuinfo = row;
			this.menuFn(event);
		},
		//点击他处隐藏菜单
		clickRow(event) {
			let menu = document.querySelector("#menu");
			if (menu) {
				menu.style.display = "none";
			}
		},
		//设置保留小数位数
		towNumber(val) {
			// this.xiaoshu = this.$store.state.common.company.xssz1;
			return Number(val).toFixed(2);
		},
		/* 输入时 */
		inputFocus(e, row, scope) {
			var num = this.inputLimit(e, 12, 2, row, "adjustAmount");
			console.log("🚀 >> inputFocus >> num:", num);
		},
		/* 
            限制输入框只可以输入数字以及负号
            且整数位最大可输入intMax位
            小数位最大可输入dotMax位
            name：  绑定对象键值
            intMax：整数最大位数
            dotMax：小数最大位数
        */
		inputLimit(num, intMax, dotMax, row, name) {
			// 类型过滤
			if (num === undefined || num === null) {
				return "0";
			}
			var next = num + "";
			/* 如果有单位 */
			/* 单位只允许是-，且在第一位 */
			/* 第一位不是-号 则过滤掉所有多余符号*/
			var hasCompany = next.indexOf("-") === 0 ? true : false;
			var res = next.match(/-/g);
			if (hasCompany && res && res.length === 1) {
				/* 负号在第一位，且只有一个负号,正常流程*/
				/* 拿走第一个负号以后需，不允许有其他任何负号 */
				next = next.substring(1);
				/* 如果有小数 */
				if (next.indexOf(".") !== -1) {
					var temp = next.split(".");
					/* 保证 整数部分、小数部分 全部没有怪异符号在中间 */
					var intNum = temp[0].replace(/[^0-9]/g, "");
					var dotNum = temp[1].replace(/[^0-9]/g, "");
					next = intNum + "." + dotNum;
					this.$set(row, name, next);
				} else {
					/* 如果没有小数 */
					next = next.replace(/[^0-9]/g, "");
					this.$set(row, name, next);
				}
			} else {
				/* 负号不在第一位，或者有其他怪异符号 */
				if (next.indexOf(".") !== -1) {
					/* 如果有小数 */
					var temp = next.split(".");
					/* 保证 整数部分、小数部分 全部没有怪异符号在中间 */
					var intNum = temp[0].replace(/[^0-9]/g, "");
					var dotNum = temp[1].replace(/[^0-9]/g, "");
					var final = (hasCompany ? "-" : "") + intNum + "." + dotNum;
					this.$set(row, name, final);
					return "0";
				} else {
					/* 如果没有小数 */
					var final = next.replace(/[^0-9]/g, "");
					this.$set(row, name, final);
					return "0"; // 这里可以根据需求return不同数据，这里return 0便于判断后续操作是否执行，如果输入不合法字符，直接干掉不合法字符，不需要执行后面逻辑了
				}
			}
			if (next !== "0" && Number(next)) {
				var resNum = "";
				/* 如果有小数 */
				if (next.indexOf(".") !== -1) {
					var arr = next.split(".");
					arr[0] = arr[0].length > intMax ? arr[0].substring(0, intMax) : arr[0];
					if (arr[1] !== "") {
						arr[1] = arr[1].length > dotMax ? arr[1].substring(0, dotMax) : arr[1];
						var result = arr.join(".");
						resNum = Number(hasCompany ? "-" + result : result).toFixed(arr[1].length);
					} else {
						var result = arr.join(".");
						resNum = hasCompany ? "-" + result : result;
					}
					this.$set(row, name, resNum);
					return resNum;
				} else {
					/* 如果没小数 一串数字，只需要限制位数*/
					resNum = num.length > intMax ? num.substring(0, intMax) : num;
					this.$set(row, name, resNum);
				}
				return resNum;
			}
		},

		// 获取权限
		async getPower() {
			try {
				const powerData = await this.$API.HKAPI({
					type: "powertb",
				});
				this.$store.commit("common/UPDATE_POWER", powerData);
			} catch (error) {
				this.$store.commit("common/UPDATE_POWER", {});
			}
		},

		// 检查权限，有 返回 true
		checkPower(power) {
			const PowerList = this.$store.state.common.Power;
			for (let i = 0, l = PowerList.length; i < l; i++) {
				if (PowerList[i].id == power) {
					return true;
				}
				if (Object.hasOwnProperty.call(PowerList[i], "children")) {
					for (let j = 0, len = PowerList[i].children.length; j < len; j++) {
						if (PowerList[i].children[j].id == power) {
							return true;
						}
					}
				}
				if (i === PowerList.length - 1 && PowerList[i].id != power) return false;
			}
		},

		// 获取云设置
		async downLoadSettings(uid) {
			const backData = await this.$API.HKAPI({
				type: "get_shezhi",
				uid,
			});
			if (uid == backData.data.Uid) {
				let Base64 = require("js-base64").Base64;
				// this.$store.commit("common/DOWNLOAD_SETTINGS", JSON.parse(JSON.parse(Base64.decode(backData.data.custom)))); //解密
				localStorage.setItem("settings", JSON.parse(Base64.decode(backData.data.custom)));
				// this.$store.commit("common/DOWNLOAD_SETTINGS", this.$qs.parse(backData.data.custom));
			} else {
				this.$store.commit("common/DOWNLOAD_SETTINGS", {});
			}
		},
		// 获取云打印设置//需要完善
		async downLoadDysz() {
			const backData = await this.$API.HKAPI({
				type: "get_print_shezhi",
			});
			const temp = {};
			for (let i = 0; i < backData.data.data.length; i++) {
				temp[backData.data.data[i].djmc] = {};
				temp[backData.data.data[i].djmc].PrintInfo = {};
				temp[backData.data.data[i].djmc].PrintInfo.sortData = this.$qs.parse(backData.data.data[i].tablecss);
				temp[backData.data.data[i].djmc].PrintInfo.DyFontSize = backData.data.data[i].zt;
				temp[backData.data.data[i].djmc].PrintInfo.dymb = backData.data.data[i].dymb;
				temp[backData.data.data[i].djmc].PrintInfo.mb_top = backData.data.data[i].mb_top;
				temp[backData.data.data[i].djmc].PrintInfo.mb_down = backData.data.data[i].mb_down;
			}
			if (backData.data.length != 0) {
				this.$store.commit("common/DOWNLOAD_DYSZ", temp);
			} else {
				this.$store.commit("common/DOWNLOAD_DYSZ", {});
			}
		},

		// 个性化设置->浏览器缓存->上传设置
		async saveSettings() {
			const settings = JSON.stringify(localStorage.getItem("settings")) || {};
			let Base64 = require("js-base64").Base64;

			await this.$API.HKPOSTAPI({
				type: "gxh_shezhi",
				// zhi: this.$qs.stringify(settings),
				zhi: Base64.encode(settings),
				uid: this.$store.state.common.Token.uid,
			});
		},
		async saveAllDysz() {
			localStorage.setItem("dysz", JSON.stringify(this.$store.state.common.dysz));
			const dysz = Object.keys(this.$store.state.common.dysz);
			for (let i = 0; i < dysz.length; i++) {
				await this.$API.HKPOSTAPI({
					type: "print_shezhi",
					djmc: dysz[i],
					ziti: this.$store.state.common.dysz[dysz[i]].PrintInfo.DyFontSize,
					zhi: this.$qs.stringify(this.$store.state.common.dysz[dysz[i]].PrintInfo.sortData),
				});
			}
			this.$message.error({
				message: `${row.spmc} 已添加过`,
				center: true,
				showClose: true,
				duration: 2000,
			});
		},
		async saveBiaowei() {
			this.addDysz("biaowei", this.defaultBiaowei, this.name, "PrintInfo");
			localStorage.setItem("dysz", JSON.stringify(this.$store.state.common.dysz));
			const back = await this.$API.HKPOSTAPI({
				type: "print_shezhi",
				djmc: this.$route.query.name + "_biaowei",
				zhi: this.$qs.stringify(this.defaultBiaowei),
			});
			if (back.data.Status == 1) {
				this.$message.success({
					message: `保存成功`,
					center: true,
					showClose: true,
					duration: 2000,
				});
			}
		},
		async saveThisDysz() {
			this.loadingsave = true;
			this.addDysz("sortData", this.defaultSortData, this.name, "PrintInfo");
			this.addDysz("sortData_wxxm", this.defaultSortData_wxxm, this.name, "PrintInfo");
			this.addDysz("DyFontSize", this.form.DyFontSize, this.name, "PrintInfo");
			this.addDysz("dyzzgd", this.form.dyzzgd, this.name, "PrintInfo");
			this.addDysz("dyzzkd", this.form.dyzzkd, this.name, "PrintInfo");
			this.addDysz("dyewgd", this.form.dyewgd, this.name, "PrintInfo");
			this.addDysz("dyttys", this.form.dyttys, this.name, "PrintInfo");
			this.addDysz("kwsort", this.form.kwsort, this.name, "PrintInfo");
			this.addDysz("showzhj", this.form.showzhj, this.name, "PrintInfo");
			this.addDysz("sortData_zc", this.defaultSortData_zc, this.name, "PrintInfo");
			this.addDysz("titlezt", this.form.titlezt, this.name, "PrintInfo");
			this.addDysz("hanggao", this.form.hanggao, this.name, "PrintInfo");

			// this.addDysz("mb_top", this.form.mb_top, this.name, "PrintInfo");
			// this.addDysz("mb_down", this.form.mb_down, this.name, "PrintInfo");
			localStorage.setItem("dysz", JSON.stringify(this.$store.state.common.dysz));
			if (this.isHavexm) {
				const back = await this.$API.HKPOSTAPI({
					type: "print_shezhi",
					djmc: "wxxm",
					zhi: this.$qs.stringify(this.defaultSortData_wxxm),
				});
			}
			if (this.name == "wgkd") {
				const back = await this.$API.HKPOSTAPI({
					type: "print_shezhi",
					djmc: "wgkdzc",
					zhi: this.$qs.stringify(this.defaultSortData_zc),
				});
			}
			// qt='纸张高度|额外高度|打印抬头样式0=两行1=一行|纸张宽度|库位排序|显示合计|标题字体|表格行高'
			const back = await this.$API.HKPOSTAPI({
				type: "print_shezhi",
				djmc: this.$route.query.name,
				zhi: this.$qs.stringify(this.defaultSortData),
				...this.form,
				qt:
					this.form.dyzzgd +
					"|" +
					this.form.dyewgd +
					"|" +
					this.form.dyttys +
					"|" +
					this.form.dyzzkd +
					"|" +
					this.form.kwsort +
					"|" +
					this.form.showzhj +
					"|" +
					this.form.titlezt +
					"|" +
					this.form.hanggao +
					"|",
			});
			if (back.data.Status == 1) {
				this.$message.success({
					message: `保存成功`,
					center: true,
					showClose: true,
					duration: 2000,
				});
			}
			this.loadingsave = false;
		},
		// 添加设置状态
		addSetting(key, value, changeView = false, changeSub = false, Obj = false) {
			let view = this.$route.name;
			changeView ? (view = changeView) : view;
			let sub = this.$options.name;
			changeSub ? (sub = changeSub) : sub;
			this.$store.commit("common/ADD_SETTING", { view, sub, Obj, key, value });
		},
		// 添加打印设置状态
		addDysz(key, value, changeView = false, changeSub = false, Obj = false) {
			let view = this.$route.name;
			changeView ? (view = changeView) : view;
			let sub = this.$options.name;
			changeSub ? (sub = changeSub) : sub;
			this.$store.commit("common/ADD_DYSZ", { view, sub, Obj, key, value });
		},
		// 获取打印设置状态	changeSub：纠正 sub 值
		getDysz(key, changeView = false, changeSub = false, Obj = false) {
			let view = this.$route.name;
			changeView ? (view = changeView) : view;
			let sub = this.$options.name;
			changeSub ? (sub = changeSub) : sub;
			const dysz = this.$store.state.common.dysz;
			if (typeof dysz === "null" || typeof dysz === "undefined") return false;
			if (view && Object.hasOwnProperty.call(dysz, view)) {
				if (sub && view != sub && Object.hasOwnProperty.call(dysz[view], sub)) {
					if (Obj && Object.hasOwnProperty.call(dysz[view][sub], Obj)) {
						if (key && Object.hasOwnproperty.call(dysz[view][sub][Obj], key)) {
							return dysz[view][sub][Obj][key];
						} else {
							if (Object.hasOwnProperty.call(dysz[view][sub], key)) {
								return dysz[view][sub][key];
							} else {
								return false;
							}
						}
					} else {
						if (Object.hasOwnProperty.call(dysz[view][sub], key)) {
							return dysz[view][sub][key];
						} else {
							return false;
						}
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		// 获取设置状态	changeSub：纠正 sub 值
		getSetting(key, changeView = false, changeSub = false, Obj = false) {
			let view = this.$route.name;
			changeView ? (view = changeView) : view;
			let sub = this.$options.name;
			changeSub ? (sub = changeSub) : sub;
			const settings = this.$store.state.common.settings;
			if (typeof settings === "null" || typeof settings === "undefined") return false;
			if (view && Object.hasOwnProperty.call(settings, view)) {
				if (sub && view != sub && Object.hasOwnProperty.call(settings[view], sub)) {
					if (Obj && Object.hasOwnProperty.call(settings[view][sub], Obj)) {
						if (key && Object.hasOwnproperty.call(settings[view][sub][Obj], key)) {
							return settings[view][sub][Obj][key];
						} else {
							if (Object.hasOwnProperty.call(settings[view][sub], key)) {
								return settings[view][sub][key];
							} else {
								return false;
							}
						}
					} else {
						if (Object.hasOwnProperty.call(settings[view][sub], key)) {
							return settings[view][sub][key];
						} else {
							return false;
						}
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
	},
};
